import React from "react";

interface Props {
  message: string;
}

const ErrorMessage = ({ message }: Props) => {
  return <div className="text-danger fs-sm">{message}</div>;
};

export default ErrorMessage;
